<template>
    <div class="px-7 py-6 box-border w-full mt-4 shadow-[0_10px_20px_0px_rgba(0,0,0,0.03)] rounded relative overflow-hidden">
        <div class="w-full mb-5 flex items-center">
            <UserPermission :color="props.color" />
            <h2 class="text-body-3 text-default-1 ml-4">User Permission</h2>
        </div>
        <div
            v-if="props.loading"
            class="w-full border-box pl-10 mt-4 flex flex-col"
        >
            <div class="w-full skeleton-loader h-12 mt-2 first:mt-0"></div>
            <div class="w-full skeleton-loader h-12 mt-2"></div>
            <div class="w-full skeleton-loader h-12 mt-2"></div>
            <div class="w-full skeleton-loader h-12 mt-2"></div>
        </div>
        <div
            v-else
            class="w-full border-box pl-10 mt-4 flex flex-col"
        >
            <div
                v-for="permission in props.permissions"
                :key="permission.uid"
                class="w-full border-b border-interactive-9 box-border py-3 flex justify-between last:border-0"
            >
                <span class="text-default-1 text-body-6 capitalize">{{ permission.formattedName }}</span>
                <RadioButton
                    :value="permission.name"
                    :name="props.radioName"
                    label=""
                    :selected-value="selectedPermission"
                    @update:modelValue="emit('updatePermissions', $event)"
                />
            </div>
            <p v-if="props.hasError" class="text-body-7 font-medium mt-1 text-interactive-3"> {{ props.hintText }} </p>
        </div>
    </div>
</template>

<script setup>
import UserPermission from "@/components/icons/UserPermission";
import RadioButton from "@/components/core/RadioButton";
const emit = defineEmits(['updatePermissions']);
const props = defineProps({
    color: {
        type: String,
        required: true,
    },
    permissions: {
        type: Array,
        required: true,
    },
    radioName: {
        type: String,
        required: true,
    },
    selectedPermission: {
        type: String,
        required: true,
    },
    loading: {
        type: Boolean,
        required: true,
    }
})
</script>